export default "__VITE_ASSET__BHc12wBL__"